
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[categoryname]",
      function () {
        return require("private-next-pages/category/[categoryname].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[categoryname]"])
      });
    }
  